__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-963c77dd/_next/";